import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About Me`}</h2>
    <p>{`I am Summayya, a second-year BSc Cs student in Hyderabad. I started
my web development journey a year ago. I am an enthusiast
learner and I primarily practice MERN stack.
Technologies I have acquired are: `}</p>
    <h6>{`HTML, CSS, Javascript, React.js, Node.js, Express.js,`}</h6>
    <h6>{`C++, C, Core Java, SQL and NoSQL(MongoDB)`}</h6>
    <h6>{`Databases, Python.`}</h6>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      